<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown" class="settings-icon">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"> </i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li class="header-title">Thème de la page</li>
        <li class="adjustments-line">
          <a class="switch-trigger background-color">
            <div class="badge-colors text-center">
              <span
                v-for="item in sidebarColors"
                :key="item.color"
                class="badge filter"
                :class="[`badge-${item.color}`, { active: userConf.view.theme==item.value }]"
                :data-color="item.color"
                @click="changeSidebarBackground(item);"
              ></span>
            </div>
            <div class="clearfix"></div>
          </a>
        </li>

        <li class="header-title">MINI MENU</li>
        <li class="adjustments-line">
          <div class="togglebutton switch-sidebar-mini">
            <span class="label-switch">INACTIF</span>
            <base-switch v-model="sidebarMini" @input="minimizeSidebar"></base-switch>
            <span class="label-switch label-right">ACTIF</span>
          </div>
        </li>

        <li class="header-title">MODE SOMBRE</li>
        <li class="adjustments-line">
          <div class="togglebutton switch-change-color">
            <span class="label-switch">INACTIF</span>
            <base-switch :value="userConf.view.darkmode" @input="toggleMode"></base-switch>
            <span class="label-switch label-right">ACTIF</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { BaseSwitch } from 'src/components';
  import { mapGetters } from 'vuex';

  export default {
    name: 'sidebar-share',
    components: {
      BaseSwitch
    },
    props: {
      backgroundColor: String
    },
    computed: {
      ...mapGetters({
        userConf: 'auth/conf',
      }),
    },
    data() {
      return {
        sidebarMini: true,
        isOpen: false,
        sidebarColors: [
          { color: 'primary', active: false, value: 'primary' },
          { color: 'vue', active: false, value: 'vue' },
          { color: 'info', active: false, value: 'blue' },
          { color: 'success', active: false, value: 'green' },
          { color: 'warning', active: false, value: 'orange' },
          { color: 'danger', active: false, value: 'red' }
        ]
      };
    },
    methods: {
      updateViewConf(view) {
        this.$store.dispatch('auth/updateconf', { view });
      },
      toggleDropDown() {
        this.isOpen = !this.isOpen;
      },
      closeDropDown() {
        this.isOpen = false;
      },
      toggleList(list, itemToActivate) {
        list.forEach(listItem => {
          listItem.active = false;
        });
        itemToActivate.active = true;
      },
      changeSidebarBackground(item) {
        this.updateViewConf({...this.$store.state.auth.conf.view, theme: item.value});
        this.$emit('update:backgroundColor', item.value);
      },
      toggleMode(type) {
        this.updateViewConf({...this.$store.state.auth.conf.view, darkmode: type});
        const docClasses = document.body.classList;
        if (type) {
          docClasses.remove('white-content');
        } else {
          docClasses.add('white-content');
        }
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize();
      }
    },
    created() {
      this.unwatch = this.$store.watch(
        (state, getters) => getters.status,
        (newValue, oldValue) => {
          //console.log(`Updating from ${oldValue} to ${newValue}`);

          // Do whatever makes sense now
          // if (newValue === 'success') {
          //   this.complex = {
          //     deep: 'some deep object',
          //   };
          // }
        },
      );
    },
    beforeDestroy() {
      this.unwatch();
    },
  };
</script>
<style scoped lang="scss">
  @import '~@/assets/sass/dashboard/custom/variables';

  .settings-icon {
    cursor: pointer;
  }

  .badge-vue {
    background-color: $vue;
  }
</style>
